export default "__VITE_ASSET__DdPaV15x__"